import { Component, Input, OnInit } from '@angular/core';
import { Zone, ZoneInfo } from '@interfaces/rest/interfaces/zone';
import { AlertController, ModalController } from '@ionic/angular';
import { ProvinceService } from '@services/province.service';
import { RestService } from '@services/rest.service';
import { DpUtilsService } from 'digitup-lib/dist/digitup-lib';

export type WheelInfoType = 'zone' | 'parada' | 'target';

export interface WheelModalData {
  id: number;
  text: string;
  time?: number;
  type?: WheelInfoType;
  mongoSessionId?: string;
}

@Component({
  selector: 'app-detail-zone',
  templateUrl: './detail-zone.component.html',
  styleUrls: ['./detail-zone.component.scss'],
})
export class DetailZoneComponent implements OnInit {
  @Input() line?: any;
  config!: WheelModalData[];
  zoneName?: string;
  paradaName?: string;
  zoneInfo?: ZoneInfo;

  zone: WheelModalData[] = [];
  parada: WheelModalData[] = [];
  target: WheelModalData[] = [];

  currentTime: Date = new Date();

  constructor(
    private modalController: ModalController,
    private utils: DpUtilsService,
    private rest: RestService,
    private province: ProvinceService,
    private alertController: AlertController
  ) {
    this.province.zoneInfo$.subscribe(zoneInfo => {
      if (zoneInfo) {
        this.zoneInfo = zoneInfo;
        this.getPositions();
      }
    });
  }

  ngOnInit() {
    this.getPositions();
  }

  close() {
    this.modalController.dismiss(null)
  }

  // async dislocate(row: WheelModalData) {
  //   console.log('row', row);
  //   const alertConfig: ConfirmAlertOptions = {
  //     header: 'relocate.title',
  //     message: 'relocate.subtitle',
  //     cssClass: 'relocate',
  //     wait: true,
  //     cancel: true,
  //     buttonOk: 'general.yes',
  //     buttonCancel: 'general.no'
  //   }

  //   const result = await this.utils.showAlert(alertConfig)

  //   console.log('result', result);
  //   console.log('row?.mongoSessionId', row?.mongoSessionId);
  //   console.log('licenses', await this.province.getLicenses());
  //   console.log('drivers', await this.province.getDrivers());

  //   if (result && row?.id) {
  //     await this.utils.showLoading();
  //     await this.rest.changeQueuePosition(row?.id);
  //     await this.utils.hideLoading();
  //   }
  // }

  async dislocate(row: WheelModalData) {
    const alert = await this.alertController.create({
      header: '¿Estas seguro que quieres cambiar posición en parada?',
      message: '¿A que posición quieres cambiar?',
      cssClass: 'relocate',
      buttons: [
        {
          text: 'Ubicar en primera posición',
          id: 'first',
          role: 'first',
          cssClass: 'ok_button'
        },
        {
          text: 'Ubicar en ultima posición',
          id: 'last',
          role: 'last',
          cssClass: 'cancel_button'
        },
        {
          text: 'Cancelar',
          id: 'cancel',
          role: 'cancel'
        }
      ]
    });

    await alert.present();
    const result = await alert.onWillDismiss();

    console.log('result', result);
    if (result.role && ['first', 'last'].includes(result.role)) {
      await this.rest.changeQueuePosition(row?.id, result.role === 'first');
    }
    // if (row?.id) {
    //   await this.utils.showLoading();
    //   await this.rest.changeQueuePosition(row?.id);
    //   await this.utils.hideLoading();
    // }
  }

  transformDate(time: number) {
    return new Date(time * 1000);
  }

  async getPositions() {
    if (!this.line) {
      return;
    }
    const selectedZone = (this.zoneInfo?.zones.filter(zoneDetail => zoneDetail?._id === this.line.id)?.[0]);
    let selectedParada: Zone | undefined;
    // console.log('selectedZone', selectedZone);
    const data: WheelModalData[] = [];

    if (selectedZone?._id) {
      const zoneId = selectedZone._id;
      const zoneParadaId = selectedZone.paradaRef;
      selectedParada = this.zoneInfo?.zones?.find(zoneDetail => zoneDetail._id === zoneParadaId);
      const drivers = await this.province.getDrivers();
      let zoneDrivers = drivers?.filter(driver => driver.s === 'active' && driver.z.i?.z === zoneId);
      zoneDrivers = zoneDrivers?.sort((a, b) => {
        const dateA = a.z.i?.ez ? a.z.i.ez : 0;
        const dateB = b.z.i?.ez ? b.z.i.ez : 0;
        return dateA - dateB;
      });
      zoneDrivers?.forEach(elem => {
        if (elem.z.i?.ez && !elem.z.i?.p) {
          data.push(
            {
              id: elem.l || 0,
              text: elem.license?.taxiNumber?.toString() || '',
              time: elem.z.i?.ez,
              type: 'zone'
            }
          );
        }
      });

      if (selectedParada?.information) {
        let paradaDrivers = drivers?.filter(driver => driver.s === 'active' && driver.z.i?.p === selectedParada?._id);
        paradaDrivers = paradaDrivers?.sort((a, b) => {
          const dateA = a.z.i?.ep ? new Date(a.z.i.ep).getTime() : 0;
          const dateB = b.z.i?.ep ? new Date(b.z.i.ep).getTime() : 0;
          return dateA - dateB;
        });
        paradaDrivers?.forEach(elem => {
          if (elem.z.i?.ep) {
            data.push(
              {
                id: elem.l || 0,
                text: elem.license?.taxiNumber?.toString() || '',
                time: elem.z.i?.ep,
                type: 'parada'
              }
            );
          }
        });
      }

      const targetDrivers = drivers?.filter(driver => driver.s === 'occupied' && driver.z.t && (driver.z.t === zoneId || driver.z.t === zoneParadaId));
      targetDrivers?.forEach(elem => {
        if (elem.z.t) {
          data.push(
            {
              id: elem.l || 0,
              text: elem.license?.taxiNumber?.toString() || '',
              type: 'target'
            });
        }
      });
    }

    this.config = data;
    this.zoneName = selectedZone?.name
    this.paradaName = selectedParada?.name || '';

    this.zone = this.config.filter(elem => elem.type === 'zone');
    this.parada = this.config.filter(elem => elem.type === 'parada');
    this.target = this.config.filter(elem => elem.type === 'target');
  }
}
